import { Box } from '@mui/material';
import BakeasyNavigationDrawer, { DrawerHeader } from '../drawer/BakeasyNavigationDrawer';
import Footer from '../layouts/BakeasyFooter';
import { useState } from 'react';

interface BakeasyAppLayoutProps {
  component: any;
}

function BakeasyAppLayout(props: BakeasyAppLayoutProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const handleDrawerStateChange = (open: boolean) => {
    setIsDrawerOpen(open);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'fixed',
        bottom: '5px',
        right: '0px',
        left: '0px',
        top: '0px'
      }}
    >
      <BakeasyNavigationDrawer onDrawerStateChange={handleDrawerStateChange} />
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 1, overflow: 'auto', backgroundColor: '#e7e7e7' }}
      >
        <DrawerHeader />
        {props?.component}
      </Box>

      <Footer isDrawerOpen={isDrawerOpen} />
    </Box>
  );
}

export default BakeasyAppLayout;
